import { render, staticRenderFns } from "./faxComponent.vue?vue&type=template&id=147317ba&"
import script from "./faxComponent.vue?vue&type=script&lang=js&"
export * from "./faxComponent.vue?vue&type=script&lang=js&"
import style0 from "./faxComponent.vue?vue&type=style&index=0&id=147317ba&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports